import _ from 'lodash';
import React from 'react';
import { cx, ErrorBox, PropTypes } from '~/utils';
import { PickList } from '~/components';
import app from '~/app';
import { useState, useEffect, useCallback, useSpatialNav } from '~/hooks';
import { log } from '@swiper/core';

function runFetcher( opts ) {
  const query = {
    ...opts.query,
    [ opts.field ] : opts.input,
  };
  if ( opts.service ) {
    const service = opts.service.replace( /^(\/api\/)?/u, '/api/' );
    log.debug( `Fetching ${opts.field}=~"${opts.input}" from ${service}` );
    return app.service( service ).find( { query } );
  }
  throw new Error( `Unable to fetch for LiveSelector` );
}

export function LiveSelector( props_in ) {
  const {
    placeholder, service, field, query,
    className, onAdd, ...props
  } = props_in;
  const [ items, setItems ] = useState( [] );
  const [ input, setInput ] = useState( '' );
  const [ error, setError ] = useState();

  useSpatialNav( useCallback( ( key, ev, spatial ) => {
    // letters + space
    if ( /^[abcdefghijklmnopqrstuvwxyz ]$/iu.test( key ) ) {
      setInput( prev => prev + key );
      return true;
    }
    if ( key === 'Backspace' ) {
      setInput( prev => prev.slice( 0, -1 ) );
      return true;
    }
  }, [ setInput ] ) );
  useSpatialNav( useCallback( ( key, ev, spatial ) => {
    if ( key === 'Enter' && _.isFunction( onAdd ) ) {
      log.debug( 'Adding', { input } );
      onAdd( input );
      return true;
    }
  }, [ input, onAdd ] ) );

  useEffect( () => {
    runFetcher( { service, field, input, query } )
      .then( res => setItems( res ) )
      .catch( err => setError( err ) );
  }, [ field, input, service, query ] );

  useEffect( () => {
    log.debug( 'LiveSelector', query, items );
  }, [ query, items ] );

  if ( error ) return <ErrorBox error={error} />;
  const classes = cx( 'live-selector', className );
  return (
    <div className={classes}>
      <h1>&nbsp;{input}&nbsp;</h1>
      <PickList items={items} {...props} selectors="numbers" />
    </div>
  );
}
LiveSelector.propTypes = {
  placeholder   : PropTypes.string.isRequired,
  service       : PropTypes.string,
  field         : PropTypes.string.isRequired,
  query         : PropTypes.object,
  className     : PropTypes.className,
  onAdd         : PropTypes.func,
};
LiveSelector.defaultProps = {
  placeholder   : 'Begin typing',
  field         : 'name',
  query         : {},
};
